import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, switchMap, take } from 'rxjs';

import { AI_API_ROOT } from '../di';
import { ChatHistoryItem, ChatHistoryMessage } from '../models/ai-chat-history.model';

@Injectable({ providedIn: 'root' })
export class AIChatHistoryService {
	private http = inject(HttpClient)
	private api$ = inject(AI_API_ROOT)

	getHistory(): Observable<ChatHistoryItem[]> {
		return this.api$.pipe(
			take(1),
			switchMap(url => this.http.get<ChatHistoryItem[]>(`${url}/api/AiChat/history`))
		)
	}

	getMessages(threadId: string): Observable<ChatHistoryMessage[]> {
		return this.api$.pipe(
			take(1),
			switchMap(url => this.http.get<ChatHistoryMessage[]>(`${url}/api/AiChat/history/${encodeURIComponent(threadId)}/messages`))
		)
	}

	deleteThread(threadId: string): Observable<boolean> {
		return this.api$.pipe(
			take(1),
			switchMap(url => this.http.delete<boolean>(`${url}/api/AiChat/history/${encodeURIComponent(threadId)}`))
		)
	}
}
